export enum ActionTypes {
  SET_CUSTOM_DATA = 'CONFIGURATOR/SET_CUSTOM_DATA',
  RESET_CONFIGURATION = 'CONFIGURATOR/RESET_CONFIGURATION',
}
